import React from 'react';
import HighlightedText from './HighlightedText';
import CopyToClipboardIcon from './CopyToClipboardIcon';

interface Props {
	text: string;
}

const CopyableText = (props: Props) => {
	return (
		<HighlightedText
			text={props.text}
			endAdornment={<CopyToClipboardIcon text={props.text} showTooltip showCopyNotification />}
		/>
	);
};

export default CopyableText;
